import { render, staticRenderFns } from "./FabricDetail.vue?vue&type=template&id=63997a47&scoped=true"
import script from "./FabricDetail.vue?vue&type=script&lang=js"
export * from "./FabricDetail.vue?vue&type=script&lang=js"
import style0 from "./FabricDetail.vue?vue&type=style&index=0&id=63997a47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63997a47",
  null
  
)

export default component.exports